import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'tk-vehicle-control-indicator-singnal-value',
    // template: `
    // <svg width="16" height="16">

    // <rect x="0" y="10" width="4" height="6" fill="#ccc"/>
    // <rect x="6" y="6" width="4" height="10" fill="#ccc"/>
    // <rect x="12" y="0" width="4" height="16" fill="#ccc"/>


    // <rect *ngIf="value > 0" x="0" y="10" width="4" height="6" fill="#000"/>
    // <rect *ngIf="value >= 8" x="6" y="6" width="4" height="10" fill="#000"/>
    // <rect *ngIf="value >= 16" x="12" y="0" width="4" height="16" fill="#000"/>
    // </svg>
    // `
    templateUrl: './vehicle-control-indicator-signal-value.component.html',
    styleUrls: ['./vehicle-control-indicator-signal-value.component.less'],
    encapsulation: ViewEncapsulation.None
})
export class VehicleControlIndicatorSignalValueComponent implements OnChanges {
    @Input()
    public value?: number;

    @Input()
    type?: string;

    public signalValue = 0;

    public ngOnChanges(changes: SimpleChanges) {
        if (changes && changes['value']) {
            const _value = changes['value'].currentValue;

            if (this.type === 'GSM') {
                this.signalValue = this.getForGSM(_value);
            }
            if (this.type === 'GPS') {
                this.signalValue = this.getForGPS(_value);
            }
        }
    }

    getForGPS(_value: number): number {
        let signalValue;
        if (_value >= 0 && _value < 5) {
            signalValue = 0;
        } else if (_value >= 5 && _value < 7) {
            signalValue = 1;
        } else if (_value >= 7 && _value < 9) {
            signalValue = 2;
        } else if (_value >= 9 && _value < 12) {
            signalValue = 3;
        } else if (_value >= 12) {
            signalValue = 4;
        } else {
            signalValue = 0;
        }
        return signalValue;
    }


    getForGSM(_value: number): number {
        let signalValue;
        if (_value >= 0 && _value < 8) {
            signalValue = 1;
        } else if (_value >= 8 && _value < 16) {
            signalValue = 2;
        } else if (_value >= 16 && _value < 24) {
            signalValue = 3;
        } else if (_value >= 24) {
            signalValue = 4;
        } else {
            signalValue = 0;
        }
        return signalValue;
    }

}
